import axiosClient from "../client_axios";
import { CALL, CALL_PUBLIC } from "../endpoint";
import { ContextApi } from "../types/api-type";
import { LocalStorageService } from "../../../helpers";
import useConfigEnv from "../../../zustand";

const ActionService = {
  // Load Action

  // Call Button
  async callButton({
    model,
    ids = [],
    context,
    method,
  }: {
    model: string;
    ids: Record<string, any>[] | any;
    context: ContextApi;
    method: any;
  }) {
    try {
      const jsonData = {
        model: model,
        method: method,
        ids: ids,
        kwargs: {
          specification: {
            invoice_payments_widget: {
              fields: {
                content: {
                  fields: {
                    journal_name: {},
                  },
                },
              },
            },
            company_id: {
              fields: {
                logo: {},
                short_name: {},
                street: {},
                street2: {},
                name: {},
                city: {},
              },
            },
            qr_raw_data: {},
            net_total_after_credit: {},
            net_total_after_credit_word: {},
            qr_string: {},
            name: {},
            is_mix_va: {},
            amount_total: {},
            narration: {},
            des_payment: {},
            invoice_date: {},
            invoice_date_due: {},
            create_date: {},
            transaction_datetime_current: {},
            payment_account_move_transaction_widget: {},
            fund_usage_json: {},
            list_balance_applied: {},
            journal_id: {},
            partner_id: {
              fields: {
                id: {},
                stud_id: {},
                display_name: {},
                tmp_stud_id: {},
              },
            },
            date: {},
            invoice_line_ids: {
              fields: {
                product_id: {
                  fields: {
                    id: {},
                    name: {},
                    default_code: {},
                  },
                },
                quantity: {},
                price_unit: {},
                discount: {},
                tax_ids: {
                  fields: {
                    id: {},
                    display_name: {},
                  },
                },
                price_total: {},
                price_subtotal: {},
              },
            },
            amount_residual: {},
            tuition_program_id: {
              fields: {
                is_payment_partial: {},
                name: {},
                display_name: {},
                is_surcharge_overdue: {},
                due_date: {},
                res_partner_bank_id: {
                  fields: {
                    acc_number: {},
                  },
                },
                tuition_program_parent_id: {
                  fields: {
                    name: {},
                  },
                },
              },
            },
            payment_state: {},
            invoice_stage: {},
            state: {},
            move_type: {},
            amount_total_words: {},
            payment_url: {},
            invoice_payment_total_amount: {},
          },
        },
        with_context: context,
      };
      const state = useConfigEnv.getState() as any;
      const env = state?.env;
      let db = "";
      if (env?.apiCall) {
        try {
          const urlObj = new URL(env.apiCall);
          db = urlObj.searchParams.get("db") || "";
        } catch (e) {
          console.error("Error parsing db from apiCall:", e);
        }
      }

      const token = LocalStorageService.getAccessToken();
      let endpoint = token ? CALL : CALL_PUBLIC;
      if (db) {
        endpoint = `${endpoint}?db=${db}`;
      }

      return axiosClient.post(endpoint, jsonData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.error("Error when calling button action:", error);
      throw error;
    }
  },
};

export default ActionService;
